// src/pages/Locations.js
// Page catégorie Locations (longue durée) - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import CategoryBar from '../components/home/CategoryBar';
import { useListings } from '../hooks/useListings';

const Locations = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useListings();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const demoListings = [
      {
        id: 1,
        slug: 'appartement-moderne-bonapriso-1',
        title: 'Appartement moderne meublé',
        quartier: 'Bonapriso',
        city: 'Douala',
        price: 250000,
        priceType: 'perMonth',
        category: 'locations',
        images: ['/images/placeholder.png'],
        bedrooms: 2,
        bathrooms: 1,
        area: 85,
      },
      {
        id: 4,
        slug: 'villa-luxe-bastos-4',
        title: 'Villa de luxe avec piscine',
        quartier: 'Bastos',
        city: 'Yaoundé',
        price: 500000,
        priceType: 'perMonth',
        category: 'locations',
        images: ['/images/placeholder.png'],
        bedrooms: 4,
        bathrooms: 3,
        area: 250,
      },
    ];
    setListings(demoListings);
  }, []);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Locations longue durée au Cameroun | Fynho</title>
        <meta name="description" content="Appartements et maisons à louer au mois à Douala, Yaoundé et partout au Cameroun." />
        <meta name="keywords" content="location Douala, appartement à louer Yaoundé, maison à louer Cameroun, location mensuelle" />
        <link rel="canonical" href="https://fynho.com/locations" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
        <div style={styles.title}>🏠 {t('categories.locations')}</div>
      </div>

      <CategoryBar />

      <div style={styles.subtitle}>
        Appartements et maisons au mois · {listings.length} annonces
      </div>

      <ListingGrid listings={listings} loading={loading} />
    </div>
  );
};

export default Locations;